const dialog = "dibd6lpiej";
const heading = "dibh1v7jmlr";
const body = "dibb1d32wa2";
const footerRule = "dibfte15en";
const footerBody = "dibf16atjj6";
const actionList = "diba1ykbgqn";

export { actionList, body, dialog, footerBody, footerRule, heading };
import "./molecule.dialog.style.linaria.module.css";
//# sourceMappingURL=molecule.dialog.style.js.map
